// extracted by mini-css-extract-plugin
var _1 = "TimelockStakingStyle-module__timeLockNotice___CkUy9";
var _2 = "TimelockStakingStyle-module__timeLockOptionLabel___Wsyq6";
export { _1 as "timeLockNotice", _2 as "timeLockOptionLabel" }
